/**
 * ProductsTabs Section Component
 *
 * Renders status filter tabs for the product listing.
 * Wraps DataTableTabs with product-specific configuration.
 */

import { useMemo } from 'react';
import { DataTableTabs } from '../../DataTable/DataTableTabs';
import { useTranslation } from '../../../hooks/useTranslation';
import type { ProductsTabsProps, ProductPublishedStatus, ProductTab } from '../types';
import { PRODUCT_PUBLISHED_STATUS_VALUES } from '../types';

export function ProductsTabs({
  currentStatus,
  onStatusChange,
  disabled = false,
  layoutId,
  className,
}: ProductsTabsProps) {
  const { t } = useTranslation();

  const tabs = useMemo<ProductTab[]>(() => PRODUCT_PUBLISHED_STATUS_VALUES.map((status) => ({
    key: status,
    label: t(`tabs.${status}`),
  })), [t]);

  return (
    <DataTableTabs<ProductPublishedStatus>
      tabs={tabs}
      value={currentStatus}
      onValueChange={onStatusChange}
      disabled={disabled}
      layoutId={layoutId}
      className={className}
    />
  );
}
